import Skeleton from "react-loading-skeleton";

export function SignatureSkeleton() {
  return (
    <li className="tw:flex tw:flex-col tw:gap-2 tw:leading-none">
      <Skeleton height={14} width={80} />
      <Skeleton height={20} width={140} />
    </li>
  );
}
